<script setup lang="ts">
import { useTranslations } from '@/composables/useTranslations';

interface Props {
    priceDisplay: string;
    showNightInfo?: boolean;
    variant?: 'default' | 'compact';
    card?: 'quickPrice' | 'reservation';
}

withDefaults(defineProps<Props>(), {
    showNightInfo: true,
    variant: 'default',
});

const { t } = useTranslations();
</script>

<template>
    <div :class="['text-center', variant === 'compact' ? 'space-y-1' : 'mt-6 space-y-2']">
        <p :class="['text-dark', variant === 'compact' ? 'text-base' : 'text-lg']">{{ t('quickPrice.totalPrice') }}:</p>
        <p :class="['font-bold text-primary', variant === 'compact' ? 'text-xl' : 'text-2xl']">
            {{ priceDisplay }}
        </p>
        <p v-if="showNightInfo && card === 'quickPrice'" class="mt-1 text-sm text-gray-600">
            {{ t('quickPrice.nightSupplement') }}
        </p>
    </div>
</template>
